import * as React from "react";
import { Link } from "gatsby";
import "./Header.css";
import logo from "../../media/logo.svg";
import name from "../../media/name.svg";

class Header extends React.Component {
  constructor() {
    super();
    this.state = {
      isMenuOpen: false,
    };

    this.onMenuBtnClick = this.onMenuBtnClick.bind(this);
    this.onMobMenuItemClick = this.onMobMenuItemClick.bind(this);
  }

  onMenuBtnClick() {
    this.setState({ isMenuOpen: !this.state.isMenuOpen });
  }

  onMobMenuItemClick() {
    this.setState({ isMenuOpen: false });
  }

  render() {
    return (
      <div className="bg-gray-100">
        <div
          className="
            top-bar
            max-w-screen-xl
            px-3
            py-3
            h-16
            flex
            items-center
            z-20
            m-auto
          "
        >
          <div className="brand flex m-0">
            <Link to="/">
              <img className="h-10 w-12" src={logo} alt="Nawe Robotics" />
            </Link>
            <Link to="/">
              <div className="name absolute md:w-auto md:relative md:mx-2 mr-0">
              <img
                className="h-10 m-auto"
                src={name}
                alt="Nawe Robotics"
              />
              </div>
            </Link>
          </div>
          <div className="nav-bar-mobile absolute right-0 px-4 w-20 md:hidden">
            <div
              className={`
                menu-btn-icon
                -mr-4
                h-12
                justify-center
                items-center
                flex
                cursor-pointer
                dont-highlight-on-touch
              ${this.state.isMenuOpen ? "open" : null}`}
              onClick={this.onMenuBtnClick}
            >
              <div className="menu-btn-burger bg-black h-1 w-6"></div>
            </div>
          </div>
          <div
            className={`
              nav-menu-mobile
              absolute
              left-0
              right-0
              select-none
              z-50
              md:hidden
              ${this.state.isMenuOpen ? "open" : "close"}
            `}
          >
            <Link
              to="/"
              className="dont-highlight-on-touch"
              onClick={this.onMobMenuItemClick}
            >
              <div
                className="
                  nav-menu-item
                  text-center text-lg
                  leading-16
                  h-16
                  bg-gray-100
                  border-t-1 border-black
                "
              >
                <span className="">Home</span>
              </div>
            </Link>
            <Link
              to="/products/"
              className="dont-highlight-on-touch"
              onClick={this.onMobMenuItemClick}
            >
              <div
                className="
                  nav-menu-item
                  text-center text-lg
                  leading-16
                  h-16
                  bg-gray-100
                  border-t-1 border-black
                "
              >
                <span className="">Products</span>
              </div>
            </Link>
            <Link
              to="/contactus/"
              className="dont-highlight-on-touch"
              onClick={this.onMobMenuItemClick}
            >
              <div
                className="
                  nav-menu-item
                  text-center text-lg
                  leading-16
                  h-16
                  bg-gray-100
                  border-t-1 border-b-1 border-black
                "
              >
                <span className="">Contact Us</span>
              </div>
            </Link>
          </div>
          <div className="nav-bar-desktop hidden pt-1 md:block mr-0 ml-auto">
            <Link to="/" className="dont-highlight-on-touch">
              <div
                className="
                  nav-bar-item
                  text-xl
                  inline-block
                  w-15
                  mr-6
                  px-3
                  py-1
                  select-none
                  rounded-sm
                "
              >
                <span className="">Home</span>
              </div>
            </Link>
            <Link to="/products/" className="dont-highlight-on-touch">
              <div
                className="
                  nav-bar-item
                  text-xl
                  inline-block
                  w-15
                  mr-4
                  px-3
                  py-1
                  select-none
                  rounded-sm
                "
              >
                <span className="">Products</span>
              </div>
            </Link>
            <Link className="dont-highlight-on-touch" to="/contactus/">
              <div
                className="
                  nav-bar-item
                  text-xl
                  inline-block
                  w-15
                  mr-4
                  px-2
                  py-1
                  select-none
                  rounded-sm
                "
              >
                <span className="">Contact Us</span>
              </div>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

export default Header;
